<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="scheme.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field-checkbox mb-3">
            <p-checkbox
              [(ngModel)]="scheme.isDefault"
              [binary]="true"
              inputId="isDefault"></p-checkbox>
            <label [for]="'isDefault'">По-умолчанию</label>
            <small
              *ngIf="errors?.isDefault"
              class="p-error">
              {{ errors.isDefault | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Аудиторы</label>
            <crm-user-and-group-multi-select
              [(selectedEntities)]="auditors"
              [rememberSelected]="true"
              (selectedEntitiesChange)="onChangeUsersAndGroup('auditor')"
              appendTo="body"></crm-user-and-group-multi-select>
          </div>

          <div class="field">
            <label class="font-medium">Доступ</label>
            <crm-user-and-group-multi-select
              [(selectedEntities)]="accessUsers"
              [rememberSelected]="true"
              (selectedEntitiesChange)="onChangeUsersAndGroup('access')"
              appendTo="body"></crm-user-and-group-multi-select>
          </div>

          <div class="field flex flex-column align-items-start">
            <label class="font-medium required-field mb-2">Тип</label>
            <p-selectButton
              [options]="typeList"
              [(ngModel)]="scheme.type"></p-selectButton>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Согласователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="scheme.users"
              [isFloatLabel]="false"
              appendTo="body"
              [isError]="$any(errors?.users)"></crm-user-multi-select>
            <small
              *ngIf="errors?.users"
              class="p-error">
              {{ errors.users | join }}
            </small>

            <crm-table
              *ngIf="scheme.users?.length && scheme.type === ApprovalSchemeTypeEnum.SEQUENTIAL"
              name="approval.scheme.form"
              [columns]="columns"
              [values]="scheme.users">
              <ng-template
                #rowTemplate
                let-user="item"
                let-index="rowIndex">
                <tr [pReorderableRow]="index">
                  <td>
                    <span
                      class="pi pi-bars"
                      pReorderableRowHandle></span>
                  </td>
                  <td>{{ index + 1 }}. {{ user.name }}</td>
                </tr>
              </ng-template>
            </crm-table>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.APPROVAL_SCHEME"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="approvalSchemeService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveScheme()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete && !scheme?.['isDefault']"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteScheme()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
